import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import RetryIcon from '@material-ui/icons/Refresh';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { filesActionCreators, IUploadFile } from '../../ducks/files';

interface IFailedUploadListItemProps {
  file: IUploadFile;
}

export const FailedUploadListItem = React.memo<IFailedUploadListItemProps>(({ file }) => {
  const dispatch = useDispatch();
  const retryUpload = React.useCallback(() => dispatch(filesActionCreators.uploadRequest(file)), [file]);
  return (
    <ListItem>
      <ListItemText primary={file.file.name} />
      <ListItemSecondaryAction>
        <IconButton onClick={retryUpload}>
          <RetryIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
});
